import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import Alerts from '../../utils/alerts';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';


import {
    Box,
    colors,
    Avatar,
    Icon,
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
    Chip,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));


const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.orange[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const getIconColor = (item) => {
    if (item.rlz == 3) {
        return { color: colors.green[600] }
    } else if (item.sxc || item.hsv || item.dca || item.dia) {
        return { color: colors.yellow[600] }
    } else {
        return { color: colors.red[600] }
    }
}


const Print = ({ item, open, closePrint, generateOTs, selecteds }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [zipgen, setZipgen] = useState(false);

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const onChangeZipType = (e) => {
        setZipgen(e.target.checked);
    }

    const onItemCheck = (e, values, item) => {
        for (let index = 0; index < values.ocorrencias.length; index++) {
            const element = values.ocorrencias[index];
            if (element.id == item.id) {
                if (e.target.checked) {
                    selecteds.push(element.id);
                } else {
                    selecteds.pop(element.id)
                }
            }
        }
    }

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Geração de Ordens de Atendimento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                            })
                        }
                        onSubmit={(values, formik) => {
                            generateOTs(values, selecteds, zipgen);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>


                                <TableContainer component={PerfectScrollbar}>
                                    <Table stickyHeader size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Agência
                                                </TableCell>
                                                <TableCell>
                                                    Ocorrência
                                                </TableCell>
                                                <TableCell>
                                                    Tipo
                                                </TableCell>
                                                <TableCell>
                                                    Hora
                                                </TableCell>
                                                <TableCell>
                                                    Veículo
                                                </TableCell>
                                                <TableCell>
                                                    Observação
                                                </TableCell>
                                                <TableCell>
                                                    PDF
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {item.ocorrencias.map((agendamento) => (
                                                <TableRow hover key={agendamento.id} className={classes.root}>
                                                    <TableCell>
                                                        <Box
                                                            noWrap="true"
                                                            alignItems="center"
                                                            display="flex"
                                                        >
                                                            <Avatar
                                                                className={classes.avatar}
                                                            >
                                                                <Icon component={RiAlarmWarningFill} style={getIconColor(agendamento)} ></Icon>
                                                            </Avatar>
                                                            {agendamento.codigo} - {agendamento.agencia}
                                                        </Box>
                                                        <Box mt={2} >
                                                        </Box>

                                                    </TableCell>
                                                    <TableCell>
                                                        <Box
                                                            noWrap="true"
                                                            alignItems="center"
                                                            display="flex"
                                                            onClick={() => { }}
                                                        >
                                                            OT:{agendamento.ot}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Chip variant="outlined" size='small' label={agendamento.tpo} style={{ backgroundColor: agendamento.cor, color: (agendamento.cor == 'yellow' ? 'black' : 'white') }}>
                                                        </Chip>
                                                    </TableCell>
                                                    <TableCell>
                                                        {agendamento.hr}
                                                    </TableCell>
                                                    <TableCell>
                                                        {agendamento.vei}
                                                    </TableCell>
                                                    <TableCell>
                                                        {agendamento.obs}
                                                    </TableCell>
                                                    <TableCell>
                                                        <ColorCheckbox
                                                            id={'check' + agendamento.id}
                                                            onChange={(e) => onItemCheck(e, values, agendamento)}                                                           
                                                        ></ColorCheckbox>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <FormControlLabel
                                                control={<ColorCheckbox
                                                    checked={zipgen}
                                                    onChange={(e) => onChangeZipType(e)} name="zip" />}
                                                label="Gerar arquivos separados dentro de um arquivo ZIP"
                                            />
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Gerar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closePrint() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Print;
